export default __webpack_public_path__ + "static/media/integration.ded892ba.svg";